<style scoped>  

  @media only screen and (min-width: 991px) {
    .content {    
      height: calc(100vh - 210px);
      transition: 0.3s linear;
    }
  }

</style>

<template>

  <div :id="_uid" class="ui modal" :class="modalSelector">

    <div class="ui header">
      Compensação de Títulos a Receber
    </div>

    <div class="scrolling content">

      <div class="ui form" :class="{ loading }">
        <div class="fields">
          <div class="four wide field">
            <label class="form-label">Número</label>
            <input :value="compensation.id" readonly="readonly">
          </div>
          <div class="four wide field">
            <label class="form-label">Data</label>
            <input :value="$formatDate(compensation.date)" readonly="readonly">
          </div>
          <div class="eight wide field">
            <label class="form-label">Usuário</label>
            <input :value="compensation.user.name" readonly="readonly">
          </div>          
        </div>
        <div class="fields">
          <div class="four wide field">
            <label class="form-label">Título</label>
            <input :value="compensation.receivable.id" readonly="readonly">
          </div>
          <div class="four wide field">
            <label class="form-label">Vencimento</label>
            <input :value="$formatDate(compensation.receivable.realDueDate)" readonly="readonly">
          </div>
          <div class="four wide field">
            <label class="form-label">Valor Título</label>
            <input :value="$formatCurrency(compensation.receivable.value)" readonly="readonly">
          </div>
          <div class="four wide field">
            <label class="form-label">Saldo Atual</label>
            <input :value="$formatCurrency(compensation.receivable.balance)" readonly="readonly">
          </div>
        </div>  
        <div class="fields">
          <div class="four wide field">
            <label class="form-label">Valor da Baixa</label>
            <input :value="$formatCurrency(compensation.value)" readonly="readonly">
          </div>          
          <div class="four wide field">
            <label class="form-label">Créditos</label>
            <input :value="$formatCurrency(compensation.credits)" readonly="readonly">
          </div>
          <div class="four wide field">
            <label class="form-label">Total da Baixa</label>
            <input :value="$formatCurrency(compensation.value + compensation.credits)" readonly="readonly">
          </div>
        </div>   
      </div>

      <div class="m-t-30">
        <div class="ui basic segment no-padding no-margin">
          <h4 class="ui dividing header">Créditos</h4>
          <table class="ui celled selectable tablet stackable table">
            <thead v-if="$isDesktop">
              <tr>
                <th>Número</th>
                <th>Emissão</th>
                <th>Vencimento</th>
                <th>Valor Título</th>
                <th>Valor Baixado</th>
              </tr>  
            </thead>
            <tbody>
              <tr v-for="(settle, index) in compensation.settles">
                <td>
                  <strong class="mobile-only">Título: </strong>
                  {{ settle.receivable.id }}
                </td>
                <td>
                  <strong class="mobile-only">Emissão: </strong>
                  {{ $formatDate(settle.receivable.date) }}
                </td>   
                <td>
                  <strong class="mobile-only">Vencimento: </strong>
                  {{ $formatDate(settle.receivable.dueDate) }}
                </td>
                <td>
                  <strong class="mobile-only">Valor Título: </strong>
                  R$ {{ $formatCurrency(settle.receivable.value) }}
                </td>
                <td>
                  <strong class="mobile-only">Valor Baixado: </strong>
                  R$ {{ $formatCurrency(settle.value) }}
                </td>
              </tr>                
            </tbody>
          </table>
        </div>
      </div>

    </div>

    <div class="actions">
      <button class="ui cancel basic button">
        <i class="times icon"></i> Sair
      </button>
    </div>

  </div>

</template>

<script>

  import ReceivableService from "@/services/receivable-service"
  import modalDialog from "@/mixins/modal-dialog"

  export default {
    
    name: "ReceivableCompensationModal",

    mixins: [modalDialog],

    data() {
      return {
        compensation: { user: {}, receivable: {}, settles: [] },
        service: new ReceivableService(),
      }
    },

    methods: {

      load(compensationId) {
        this.loadCompensation(compensationId)        
        this.show()
      },

      async loadCompensation(compensationId) {

        try {

          this.compensation = await this.service.getCompensation(compensationId)
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.loading = false
        }
      },
    },
  }

</script>